import { UserModulesDto } from 'modules/userModule/userDtos';

const urlAndModules = [
  {
    service: 'usersList',
    url: '/users',
  },
  {
    service: 'usersList',
    url: '/users',
  },
  {
    service: 'addUser',
    url: '/users/add-user',
  },
  {
    service: 'newsCategoriesAdd',
    url: '/news/categories/add',
  },
  {
    service: 'newsCategoriesList',
    url: '/news/categories',
  },
  {
    service: 'allCategoriesAdd',
    url: '/all-categories/add',
  },
  {
    service: 'allCategoriesList',
    url: '/all-categories',
  },
  {
    service: 'sectionsAdd',
    url: '/sections/add',
  },
  {
    service: 'sectionsList',
    url: '/sections',
  },
  {
    service: 'addNews',
    url: '/news/add',
  },
  {
    service: 'showNews',
    url: '/news',
  },
  {
    service: 'fieldNews',
    url: '/field-news',
  },
  {
    service: 'addFieldNews',
    url: '/field-news/add',
  },
  {
    service: 'addKnowledge',
    url: '/expert-articles/add',
  },
  {
    service: 'knowledge',
    url: '/expert-articles',
  },
  {
    service: 'addNawozyTV',
    url: '/nawozy-tv/add',
  },
  {
    service: 'nawozyTV',
    url: '/nawozy-tv',
  },
  {
    service: 'fertilizationAdd',
    url: '/fertilization/add',
  },
  {
    service: 'fertilization',
    url: '/fertilization',
  },
  {
    service: 'representativesAdd',
    url: '/representatives/add',
  },
  {
    service: 'representativesList',
    url: '/representatives',
  },
  {
    service: 'distributionAdd',
    url: '/distribution/add',
  },
  {
    service: 'distribution',
    url: '/distribution',
  },
  {
    service: 'dataProtection',
    url: '/data-protection',
  },
  {
    service: 'rules',
    url: '/rules',
  },
  {
    service: 'privacy',
    url: '/privacy',
  },
  {
    service: 'serviceMap',
    url: '/service-map',
  },
  {
    service: 'fertilizationScheduleAdd',
    url: '/fertilization-schedule/add',
  },
  {
    service: 'fertilizationSchedule',
    url: '/fertilization-schedule',
  },
  {
    service: 'banners',
    url: '/banners',
  },
  {
    service: 'askExpert',
    url: '/ask-expert',
  },
  {
    service: 'askExpertAdd',
    url: '/ask-expert/add',
  },
  {
    service: 'fertilizersCategoriesAdd',
    url: '/fertilizers/categories/add',
  },
  {
    service: 'fertilizersCategories',
    url: '/fertilizers/categories',
  },
  {
    service: 'fertilizersPackAdd',
    url: '/fertilizers/pack/add',
  },
  {
    service: 'fertilizersPack',
    url: '/fertilizers/pack',
  },
  {
    service: 'fertilizersAdd',
    url: '/fertilizers/add',
  },
  {
    service: 'fertilizers',
    url: '/fertilizers',
  },
  {
    service: 'fertilizersParametersAdd',
    url: '/fertilizers-parameters/add',
  },
  {
    service: 'fertilizersParameters',
    url: '/fertilizers-parameters',
  },
  {
    service: 'gtwArtAdd',
    url: '/gtw-art/add',
  },
  {
    service: 'gtwCatAdd',
    url: '/gtw-categories/add',
  },
  {
    service: 'gtwCat',
    url: '/gtw-categories',
  },
  {
    service: 'gtwArt',
    url: '/gtw-art',
  },
  {
    service: 'gtwRequirementsAdd',
    url: '/gtw-requirements/add',
  },
  {
    service: 'gtwRequirements',
    url: '/gtw-requirements',
  },
  {
    service: 'gtwFilesAdd',
    url: '/gtw-files/add',
  },
  {
    service: 'gtwFiles',
    url: '/gtw-files',
  },
  {
    service: 'gtwEditionsAdd',
    url: '/gtw-editions/add',
  },
  {
    service: 'gtwEditions',
    url: '/gtw-editions',
  },
  {
    service: 'AGROlider',
    url: '/agro-lider',
  },
  {
    service: 'AGROliderAdd',
    url: '/agro-lider/add',
  },
  {
    service: 'fertilizersDictionary',
    url: '/fertilizers-dictionary',
  },
  {
    service: 'garden_gardenExpertArticlesAdd',
    url: '/garden/expert-articles/add',
  },
  {
    service: 'gardenExpertArticlesAdd',
    url: '/garden/expert-articles/add',
  },
  {
    service: 'garden_gardenExpertArticles',
    url: '/garden/expert-articles',
  },
  {
    service: 'gardenExpertArticles',
    url: '/garden/expert-articles',
  },
  {
    service: 'garden_gardenFertilizersAdd',
    url: '/garden/fertilizers/add',
  },
  {
    service: 'gardenFertilizersAdd',
    url: '/garden/fertilizers/add',
  },
  {
    service: 'garden_gardenFertilizers',
    url: '/garden/fertilizers',
  },
  {
    service: 'gardenFertilizers',
    url: '/garden/fertilizers',
  },
];

export const moduleUrls = (modules: UserModulesDto[]) => {
  const listModules = modules.map((module) =>
    urlAndModules.find(
      // @ts-ignore
      (moduleWithUrl) => moduleWithUrl.service === module
    )
  );
  return listModules.filter((module): module is { service: string; url: string } => !!module);
};

export const checkIfAvailable = (url: string, modules: UserModulesDto[]) => {
  if (['/password'].includes(url)) {
    return true;
  }
  return !!moduleUrls(modules).find((module) => {
  // @ts-ignore
   // console.log(url, `${module.url}/`, url.includes(`${module.url}/`));
    // @ts-ignore
    if (!module) return false;
    return (
      module.url === url ||
      url.startsWith(`${module.url}/`) ||
      `${url}/`.startsWith(`${module.url}/`)
    );
  });
};
